import React from 'react';
import EducationForm from '../../../Common/EducationForm/EducationtForm';

const EmployeeEducation = ({ document }) => {
  return <EducationForm document={document} type="employee_education" />;
};

export default EmployeeEducation;
